<GoogleSdk {apiKey} on:ready={initialise} />
<input {id} aria-label={ariaLabel} class={styleClass} {placeholder} bind:this={search} type="text" {disabled} bind:value={viewValue} on:blur={blur} on:keydown={autocompleteKeydown} autocomplete="off" />

<script>
//   import GoogleSdk from './GoogleSdk.svelte'
import GoogleSdk from './addresssdk.svelte';
  import { createEventDispatcher } from 'svelte'

  export let id = `gm-autocomplete-${Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)}`
  export let apiKey = null
  export let ariaLabel = 'Property address'
  export let placeholder = 'Property address'
  export let styleClass = ''
  export let value = null
  export let viewValue = null
  export let viewLabel = 'formatted_address'
  // export let fields = [ 'geometry', viewLabel ]
  export let fields = [ 'address_components', viewLabel ]
  // export let types = [ '(regions)' ]
  export let types = [ 'address' ]
  export let options = {componentRestrictions: { country: "us" },}

  let search
  let autocomplete
  let currentPlace
  let disabled = true

  // const acceptable_ob_counties = 

  const dispatch = createEventDispatcher()

  export function clear () {
    value = null
    viewValue = null
    currentPlace = null

    dispatch('clear')
  }

  function dropdownVisible () {
    return document.querySelectorAll('.pac-container')[0].offsetParent !== null
  }

  function autocompleteKeydown (e) {
    if (e.keyCode === 13 && dropdownVisible()) {
      e.preventDefault()
    }
  }

  function blur () {
    dispatch('blur')
    if (viewValue !== (currentPlace && currentPlace[viewLabel])) {
      clear()
    }
  }

  function initialise () {
    const google = window.google
    autocomplete = new google.maps.places.Autocomplete(
      search,
      Object.assign(
        {
          fields,
          types
        },
        options
      )
    )

    disabled = false

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()
console.log(place);
      if(place.address_components){
        let address = {}
        try {
            address['street_number'] = place.address_components.filter(e=>{return e.types.includes("street_number")})[0].short_name;
        }catch(error){
            address['street_number'] = "";
        }
        try {
        address['street'] = place.address_components.filter(e=>{return e.types.includes("route")})[0].short_name;
        }catch(error){
            address['street'] = "";
        }
        try {
        address['city'] = place.address_components.filter(e=>{return e.types.includes("locality")})[0].short_name;
        }catch(error){
            address['city'] = "";
        }
        try {
        address['state'] = place.address_components.filter(e=>{return e.types.includes("administrative_area_level_1")})[0].short_name;
        }catch(error){
            address['state'] = "";
        }
        try {
        address['county'] = place.address_components.filter(e=>{return e.types.includes("administrative_area_level_2")})[0].short_name.replaceAll(" County", "");
        }catch(error){
            address['county'] = "";
        }
        try {
        address['zipcode'] = place.address_components.filter(e=>{return e.types.includes("postal_code")})[0].short_name;
        }catch(error){
            address['zipcode'] = "";
        }
        try {
        address['address'] = `${address['street_number']} ${address['street']}`;
        }catch(error){
            address['address'] = "";
        }




        //street_number
        // address['street_number'] = place.address_components.filter(e=>{return e.types.includes("street_number")})[0].short_name;
        //street
        //city
        //state
        //county
        //zipcode
        
        // value = place.address_components;
        value = address;
        dispatch('placeChanged', { value });
      }
      if (place.geometry) {
        viewValue = place[viewLabel]
        value = viewValue
        currentPlace = place
        dispatch('placeChanged', { place, selectedPrediction: search.value })
      }
    })

    dispatch('ready')
  }
</script>
